import { HttpResult } from "widgets-for-react"
import { Metadata } from "./metadata.state"
import { makeApiCall } from "../../../utils/apiCall"

type MetadataResponse = {
  Status: number
  Title: string | null
  Description: string | null
  Thumbnail: string | null
}

export const getStaticMetadata = async (): Promise<HttpResult<Metadata | null>> => {
  const slug = window.location.pathname.substring(1)

  if(!shouldRetrieveMetaDataForSlug(slug))
    return { kind: "result", status: 200, value: null }

  try {
    const result = await makeApiCall(`/api/v1/metadata/static?slug=${slug}`)
    if (result.kind === 'result') return { kind: "result", status: 200, value: parseMetadata(result.value) }
    return { kind: "result", status: 200, value: null }
  } catch (e) {
    console.error('Error when fetching static metadata for slug', slug)
    console.error(JSON.stringify(e))
    return { kind: "result", status: 200, value: null }
  }
}

const parseMetadata = (response: MetadataResponse): Metadata => ({
  title: response.Title ?? "Gastronomixs",
  description: response.Description ?? ""
})

const shouldRetrieveMetaDataForSlug = (slug: string): boolean => {
  // Do not retrieve the static metadata for the following pages
  // We solve this in the frontend instead of backend for a few reasons:
  // - We KNOW that the backend will not have any static metadata for these pages, 
  //   so why make an unnecessary web request?
  // - Receiving a 404 from this endpoint will create noise in Application Insights
  //   that will mark these requests as failures
  // - Google (and other search engines) might pick up these urls to crawl which will also fail
  const excludedPages: string[] = [
    'nl/componenten/',
    'en/components/',
    'nl/gerechten/',
    'en/dishes/',
    'nl/blog/',
    'en/blog/',
  ];
  
  if(excludedPages.some(i => slug.startsWith(i)))
    return false;

  return true;
}